export const DEFAULT_LOCATION = {
    lat: -25.344, long: 131.031, label: "HQ"
}
export {default as initializeMatchMakingMap} from "./initialize_matchmaking_map";